import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Kiosk from "./Pages/Kiosk";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import config from "./utils/config";
import { handleConfig } from "./services/eventHandlerService";

export const ConfigContext = createContext(config);
export const useConfig = () => useContext(ConfigContext);

const queryClient = new QueryClient();

// router definition
const router = createBrowserRouter(
  [
    { path: "/kiosk/:restaurantName/:restaurantId", element: <Kiosk /> },
    { path: "/:restaurantName/:restaurantId", element: <Kiosk /> },
    { path: "/", element: <Kiosk /> }
  ],
  {
    future: { v7_startTransition: true }
  }
);

function App() {
  useEffect(() => {
    if (window.KIOSK_CONFIG) {
      const { baseUrl, restId, wrapper } = window.KIOSK_CONFIG;
      if (wrapper) localStorage.setItem("wrapper", wrapper);
      if (restId) localStorage.setItem("restaurantId", restId);
    }

    window.addEventListener("message", handleConfig);
    return () => window.removeEventListener("message", handleConfig);
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>
      </QueryClientProvider>
    </ConfigContext.Provider>
  );
}

export default App;
